function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m84.8125 122.878906h82.269531v34.132813h-82.269531zm0 0",
  fill: "#d7e9ff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m167.082031 163.839844h-82.269531c-3.773438 0-6.828125-3.054688-6.828125-6.828125v-34.132813c0-3.769531 3.054687-6.824218 6.828125-6.824218h82.269531c3.773438 0 6.828125 3.054687 6.828125 6.824218v34.132813c0 3.773437-3.054687 6.828125-6.828125 6.828125zm-75.445312-13.652344h68.621093v-20.480469h-68.621093zm0 0",
  fill: "#0e65e5"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m255.851562 275.816406c0 68.640625-55.640624 124.28125-124.28125 124.28125-68.636718 0-124.28125-55.640625-124.28125-124.28125 0-68.636718 55.644532-124.28125 124.28125-124.28125 68.640626 0 124.28125 55.644532 124.28125 124.28125zm0 0",
  fill: "#288eea"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m131.570312 406.925781c-72.292968 0-131.105468-58.816406-131.105468-131.109375 0-72.292968 58.8125-131.105468 131.105468-131.105468 72.292969 0 131.105469 58.8125 131.105469 131.105468 0 72.292969-58.8125 131.109375-131.105469 131.109375zm0-248.5625c-64.765624 0-117.453124 52.691407-117.453124 117.453125 0 64.765625 52.6875 117.457032 117.453124 117.457032 64.765626 0 117.453126-52.691407 117.453126-117.457032 0-64.761718-52.6875-117.453125-117.453126-117.453125zm0 0",
  fill: "#0e65e5"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m208.546875 178.363281c16.75 21.175781 26.824219 47.878907 26.824219 76.972657 0 68.640624-55.640625 124.28125-124.28125 124.28125-29.097656 0-55.796875-10.074219-76.976563-26.824219 22.761719 28.78125 57.914063 47.304687 97.457031 47.304687 68.636719 0 124.28125-55.640625 124.28125-124.28125 0-39.539062-18.523437-74.691406-47.304687-97.453125zm0 0",
  fill: "#0e65e5"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m131.570312 406.925781c-40.261718 0-77.726562-18.183593-102.808593-49.898437-2.152344-2.714844-1.917969-6.609375.527343-9.058594 2.457032-2.460938 6.355469-2.671875 9.0625-.527344 20.964844 16.585938 46.121094 25.351563 72.738282 25.351563 64.769531 0 117.453125-52.691407 117.453125-117.453125 0-26.621094-8.765625-51.773438-25.347657-72.742188-2.152343-2.71875-1.917968-6.609375.527344-9.0625 2.457032-2.457031 6.347656-2.667968 9.0625-.527344 31.707032 25.078126 49.890625 62.554688 49.890625 102.808594 0 72.296875-58.8125 131.109375-131.105469 131.109375zm-45.746093-22.902343c14.257812 6.046874 29.757812 9.25 45.746093 9.25 64.765626 0 117.453126-52.6875 117.453126-117.453126 0-15.988281-3.207032-31.488281-9.246094-45.753906 1.605468 8.238282 2.417968 16.691406 2.417968 25.273438 0 72.292968-58.8125 131.109375-131.105468 131.109375-8.585938 0-17.03125-.820313-25.265625-2.425781zm0 0",
  fill: "#0e65e5"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m50.328125 282.644531c-3.773437 0-6.824219-3.058593-6.824219-6.828125 0-48.558594 39.503906-88.066406 88.066406-88.066406 3.773438 0 6.824219 3.058594 6.824219 6.828125s-3.050781 6.824219-6.824219 6.824219c-41.035156 0-74.414062 33.386718-74.414062 74.414062 0 3.769532-3.054688 6.828125-6.828125 6.828125zm0 0",
  fill: "#fff"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#0e65e5"
}, React.createElement("path", {
  d: "m131.570312 122.855469c-3.773437 0-6.828124-3.058594-6.828124-6.828125v-5.964844c0-15.15625 12.335937-27.492188 27.492187-27.492188h31.457031c6.183594 0 10.34375-7.394531 10.34375-14.300781v-6.828125c0-3.769531 3.054688-6.828125 6.828125-6.828125 3.773438 0 6.824219 3.058594 6.824219 6.828125v6.828125c0 13.445313-9.171875 27.957031-23.996094 27.957031h-31.457031c-7.632813 0-13.839844 6.207032-13.839844 13.835938v5.964844c0 3.769531-3.050781 6.828125-6.824219 6.828125zm0 0"
}), React.createElement("path", {
  d: "m175.957031 60.714844h-26.632812c-3.773438 0-6.828125-3.058594-6.828125-6.828125s3.054687-6.828125 6.828125-6.828125h26.632812c3.773438 0 6.828125 3.058594 6.828125 6.828125s-3.054687 6.828125-6.828125 6.828125zm0 0"
}), React.createElement("path", {
  d: "m180.378906 40.960938c-1.300781 0-2.613281-.371094-3.78125-1.148438l-20.480468-13.652344c-3.140626-2.089844-3.988282-6.332031-1.894532-9.46875 2.082032-3.140625 6.320313-3.988281 9.46875-1.890625l20.480469 13.652344c3.140625 2.089844 3.984375 6.332031 1.890625 9.46875-1.3125 1.972656-3.480469 3.039063-5.683594 3.039063zm0 0"
}), React.createElement("path", {
  d: "m252.402344 60.714844h-26.632813c-3.773437 0-6.824219-3.058594-6.824219-6.828125s3.050782-6.828125 6.824219-6.828125h26.632813c3.773437 0 6.828125 3.058594 6.828125 6.828125s-3.054688 6.828125-6.828125 6.828125zm0 0"
}), React.createElement("path", {
  d: "m221.347656 40.960938c-2.207031 0-4.371094-1.066407-5.683594-3.039063-2.097656-3.136719-1.246093-7.378906 1.890626-9.46875l20.480468-13.652344c3.140625-2.097656 7.371094-1.246093 9.46875 1.890625 2.09375 3.136719 1.242188 7.378906-1.894531 9.46875l-20.480469 13.652344c-1.164062.777344-2.480468 1.148438-3.78125 1.148438zm0 0"
}), React.createElement("path", {
  d: "m200.863281 34.132812c-3.773437 0-6.824219-3.054687-6.824219-6.824218v-20.480469c0-3.773437 3.050782-6.828125 6.824219-6.828125 3.773438 0 6.828125 3.054688 6.828125 6.828125v20.480469c0 3.769531-3.054687 6.824218-6.828125 6.824218zm0 0"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m207.691406 341.332031c-3.773437 0-6.828125-3.054687-6.828125-6.824219v-27.308593c0-3.769531 3.054688-6.824219 6.828125-6.824219 3.773438 0 6.824219 3.054688 6.824219 6.824219v27.308593c0 3.769532-3.054687 6.824219-6.824219 6.824219zm0 0",
  fill: "#fff"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m221.34375 327.679688h-27.304688c-3.773437 0-6.828124-3.054688-6.828124-6.828126 0-3.769531 3.054687-6.824218 6.828124-6.824218h27.304688c3.773438 0 6.828125 3.054687 6.828125 6.824218 0 3.773438-3.054687 6.828126-6.828125 6.828126zm0 0",
  fill: "#fff"
});

var SvgBomb = function SvgBomb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "22px",
    viewBox: "-72 0 406 406.92736",
    width: "22px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBomb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bomb.a720049b.svg";
export { ForwardRef as ReactComponent };